/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./InspectorProfile.module.css";
import { Rating } from "@mui/material";

function ProfileDetails() {
    const [value, setValue] = React.useState(2);

    return (
        <div className={styles.profileDetails}>
            <div className={styles.imageHeader}>
                <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/a4686dc0d5d9b27398d4b75c024ab6de3ff33b27cf5962e364ec7ac121b9a4fc?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                    alt="Alexander Johnson"
                    className={styles.profileImage}
                />
            </div>
            <div className={styles.detailsContent}>
                <div className={styles.nameExperience}>
                    <div>
                        <h2 className={styles.inspectorName}>Alexander Johnson</h2>
                        <p className={styles.experience}>10+ years of experience</p>
                    </div>
                    <div className={styles.ratingContainer}>
                        <div className={styles.badgeContainer}>
                            <img
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/fc18ae70878a8489dc790b00921a556ee5f964203fda5ffa59173b41e7dd76c8?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                                alt="Achievement Badge"
                                className={styles.achievementBadge}
                            />
                            <img
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/591794cd895d7abf3b5226e10e8b28aa062f3205b1f6d74fa1a94b0bc8ebe58e?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                                alt="Verified Badge"
                                className={styles.verifiedBadge}
                            />
                        </div>
                        <div className={styles.starRating}>
                            <Rating
                                name="simple-controlled"
                                value={value}
                                onChange={(event, newValue) => {
                                    setValue(newValue);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.bioSection}>
                    <h3 className={styles.bioTitle}>Bio:</h3>
                    <p className={styles.bioText}>Introduction paragraph highlighting the inspector's background, experience, and expertise.</p>
                </div>
                <div className={styles.specialtiesSection}>
                    <h3 className={styles.specialtiesTitle}>Specialties:</h3>
                    <div className={styles.specialtiesTags}>
                        {["Historic Homes", "New Construction", "Condos"].map((specialty, index) => (
                            <span key={index} className={styles.specialtyTag}>
                                {specialty}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProfileDetails;
